import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup
} from "react-leaflet";

import L from "leaflet";
import axios from "axios";

import "leaflet/dist/leaflet.css";

import {
  MapPin,
  Activity,
  Edit,
  Trash2,
  Save
} from "lucide-react";

/* FIX LEAFLET */
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png"
});

const getRiskColor = (jumlah) => {
  if (jumlah === 0) return "#22c55e"; // hijau
  if (jumlah <= 20) return "#eab308"; // kuning
  if (jumlah <= 50) return "#f97316"; // oranye
  return "#dc2626"; // merah
};

const createCaseIcon = (jumlahKasus) => {
  const color = getRiskColor(jumlahKasus);

  return L.divIcon({
    html: `
      <div
        style="
          background:${color};
          color:white;
          width:38px;
          height:38px;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
          font-weight:bold;
          border:3px solid white;
          box-shadow:0 2px 6px rgba(0,0,0,0.3);
          font-size:13px;
        "
      >
        ${jumlahKasus}
      </div>
    `,
    className: "",
    iconSize: [38, 38]
  });
};

const KelolaGIS = () => {
  const [mapData, setMapData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [filterPeriode, setFilterPeriode] = useState("");

  const [form, setForm] = useState({
    wilayah: "",
    latitude: "",
    longitude: "",
    periode: "",
    jumlah_kasus: "",
    id_admin: 1
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        "https://api-tibismart.tifpsdku.com/api/persebaran/"
      );

      setMapData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    try {
      if (
        !form.wilayah ||
        !form.latitude ||
        !form.longitude ||
        !form.periode ||
        !form.jumlah_kasus
      ) {
        alert("Semua field wajib diisi");
        return;
      }

      if (editId) {
        await axios.put(
          `https://api-tibismart.tifpsdku.com/api/persebaran/${editId}`,
          form
        );
      } else {
        await axios.post(
          "https://api-tibismart.tifpsdku.com/api/persebaran/",
          form
        );
      }

      resetForm();
      fetchData();

    } catch (error) {
      console.log(error);
      alert("Gagal menyimpan");
    }
  };

  const handleEdit = (item) => {
    setEditId(item.id);

    setForm({
      wilayah: item.wilayah,
      latitude: item.latitude,
      longitude: item.longitude,
      periode: item.periode,
      jumlah_kasus: item.jumlah_kasus,
      id_admin: item.id_admin
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Hapus data?")) return;

    await axios.delete(
      `https://api-tibismart.tifpsdku.com/api/persebaran/${id}`
    );

    fetchData();
  };

  const resetForm = () => {
    setEditId(null);

    setForm({
      wilayah: "",
      latitude: "",
      longitude: "",
      periode: "",
      jumlah_kasus: "",
      id_admin: 1
    });
  };

  const daftarPeriode = [
    ...new Set(mapData.map((item) => item.periode))
  ];

  const filteredData = filterPeriode
    ? mapData.filter(
      (item) => item.periode === filterPeriode
    )
    : mapData;

  const totalKasus = filteredData.reduce(
    (sum, item) => sum + item.jumlah_kasus,
    0
  );

  return (
    <div className="ml-[200px] mr-0 p-5 pt-12 bg-white min-h-screen w-[calc(100%-200px)]">

      {/* HEADER */}
      <div className="mb-3">
        <h1 className="text-lg font-bold text-slate-800">
          Monitoring GIS TBC
        </h1>

        <p className="text-xs text-slate-500">

        </p>
      </div>


      <div className="bg-white border rounded-xl p-3 shadow-sm mb-3">
        <div className="flex items-center gap-3">

          <label className="text-sm font-medium">
            Filter Periode:
          </label>

          <select
            value={filterPeriode}
            onChange={(e) =>
              setFilterPeriode(e.target.value)
            }
            className="border rounded-lg px-3 py-2 text-sm"
          >
            <option value="">
              Semua Periode
            </option>

            {daftarPeriode.map((periode) => (
              <option
                key={periode}
                value={periode}
              >
                {periode}
              </option>
            ))}
          </select>

        </div>
      </div>


      {/* SUMMARY */}
      <div className="grid grid-cols-2 gap-3 mb-3">

        <div className="bg-white border rounded-xl p-3 shadow-sm">
          <div className="flex items-center gap-2">

            <MapPin size={18} className="text-blue-600" />

            <div>
              <p className="text-[11px] text-slate-500">
                Total Wilayah
              </p>

              <h2 className="text-lg font-bold">
                {mapData.length}
              </h2>
            </div>

          </div>
        </div>


        <div className="bg-white border rounded-xl p-3 shadow-sm">
          <div className="flex items-center gap-2">

            <Activity size={18} className="text-red-500" />

            <div>
              <p className="text-[11px] text-slate-500">
                Total Kasus
              </p>

              <h2 className="text-lg font-bold">
                {totalKasus}
              </h2>
            </div>

          </div>
        </div>

      </div>



      {/* FORM + MAP */}
      <div className="grid grid-cols-1 xl:grid-cols-4 gap-3">

        {/* FORM */}
        <div className="bg-white border rounded-xl p-3 shadow-sm">

          <h2 className="text-sm font-bold mb-3">
            {editId ? "Edit Lokasi" : "Tambah Lokasi"}
          </h2>

          <div className="space-y-2">

            <input
              className="w-full border rounded-lg px-3 py-2 text-sm"
              placeholder="Wilayah"
              value={form.wilayah}
              onChange={(e) =>
                setForm({
                  ...form,
                  wilayah: e.target.value
                })
              }
            />

            <input
              className="w-full border rounded-lg px-3 py-2 text-sm"
              placeholder="Latitude"
              value={form.latitude}
              onChange={(e) =>
                setForm({
                  ...form,
                  latitude: e.target.value
                })
              }
            />

            <input
              className="w-full border rounded-lg px-3 py-2 text-sm"
              placeholder="Longitude"
              value={form.longitude}
              onChange={(e) =>
                setForm({
                  ...form,
                  longitude: e.target.value
                })
              }
            />

            <input
              className="w-full border rounded-lg px-3 py-2 text-sm"
              placeholder="Periode"
              value={form.periode}
              onChange={(e) =>
                setForm({
                  ...form,
                  periode: e.target.value
                })
              }
            />

            <input
              type="number"
              className="w-full border rounded-lg px-3 py-2 text-sm"
              placeholder="Jumlah kasus"
              value={form.jumlah_kasus}
              onChange={(e) =>
                setForm({
                  ...form,
                  jumlah_kasus: parseInt(e.target.value)
                })
              }
            />

            <button
              onClick={handleSubmit}
              className="w-full bg-blue-600 text-white rounded-lg py-2 text-sm font-semibold flex items-center justify-center gap-2"
            >
              <Save size={14} />
              {editId ? "Update" : "Simpan"}
            </button>

          </div>
        </div>



        {/* MAP */}
        <div className="xl:col-span-3 bg-white border rounded-xl p-2 shadow-sm">

          <MapContainer
            center={[-7.64, 111.35]}
            zoom={11}
            style={{
              height: "320px",
              width: "100%"
            }}
            className="rounded-xl"
          >

            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {filteredData.map((item) => (
              <Marker
                key={item.id}
                position={[
                  Number(item.latitude),
                  Number(item.longitude)
                ]}
                icon={createCaseIcon(item.jumlah_kasus)}
              >
                <Popup>
                  <div className="min-w-[180px]">
                    <h3 className="font-bold text-base">
                      {item.wilayah}
                    </h3>

                    <hr className="my-2" />

                    <p>
                      <b>Periode:</b> {item.periode}
                    </p>

                    <p>
                      <b>Kasus Positif:</b> {item.jumlah_kasus}
                    </p>

                  </div>
                </Popup>
              </Marker>
            ))}

          </MapContainer>

          <div className="mt-3 flex flex-wrap gap-4 text-sm">

            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded-full bg-green-500"></div>
              <span>0 Kasus</span>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded-full bg-yellow-500"></div>
              <span>1 - 20 Kasus</span>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded-full bg-orange-500"></div>
              <span>21 - 50 Kasus</span>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded-full bg-red-600"></div>
              <span>&gt; 50 Kasus</span>
            </div>

          </div>

        </div>

      </div>



      {/* TABLE */}
      <div className="bg-white border rounded-xl p-3 shadow-sm mt-3">

        <h2 className="text-sm font-bold mb-2">
          Data Persebaran
        </h2>

        <table className="w-full text-sm">

          <thead>
            <tr className="border-b">
              <th className="py-2 text-left">Wilayah</th>
              <th className="py-2 text-left">Periode</th>
              <th className="py-2 text-left">Kasus</th>
              <th className="py-2 text-left">Aksi</th>
            </tr>
          </thead>

          <tbody>

            {filteredData.map((item) => (
              <tr
                key={item.id}
                className="border-b"
              >
                <td className="py-2">{item.wilayah}</td>
                <td className="py-2">{item.periode}</td>
                <td className="py-2">{item.jumlah_kasus}</td>

                <td className="py-2 flex gap-2">

                  <button
                    onClick={() => handleEdit(item)}
                    className="bg-yellow-500 text-white p-2 rounded-md"
                  >
                    <Edit size={13} />
                  </button>

                  <button
                    onClick={() =>
                      handleDelete(item.id)
                    }
                    className="bg-red-500 text-white p-2 rounded-md"
                  >
                    <Trash2 size={13} />
                  </button>

                </td>

              </tr>
            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default KelolaGIS;